import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";

import { SettingsProvider } from "./components/settingContext";
import { SetDefault } from "./components/loading";

let root = document.getElementById("cabi-crop-app-index");

if (root) {
  let settings = JSON.parse(root.getAttribute("data-settings"));

  settings.post_url = settings.post_url ?? '';
  settings.pageSize = settings.pageSize ?? 9;
  settings.maxterms = settings.maxterms ?? 3;
  settings.maxfilter = settings.maxfilter ?? 5;
  
  SetDefault({ title: "Please wait...", text: "" });

  ReactDOM.render(
    <React.StrictMode>
      <SettingsProvider value={settings}>
        <Router>
          <App />
        </Router>
      </SettingsProvider>
    </React.StrictMode>,
    root
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
